import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '../lib/api';
import { clearAuth } from '../lib/storage';

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      // 10-second timeout prevents the loading screen from hanging forever
      // on poor mobile connections or when the backend is briefly unreachable.
      const r = await Promise.race([
        api.get('/auth/me'),
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error('auth_timeout')), 10000)
        ),
      ]);
      setUser(r.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch (_e) { /* ignore */ }
    // Wipes both localStorage AND native Capacitor Preferences so the next
    // app launch shows the login screen instead of auto-unlocking.
    await clearAuth();
    setUser(null);
    window.location.href = '/login';
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, checkAuth, logout }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
